class ProductSkuModalController extends AbstractController
	@register()
	@inject '$uibModalInstance',
		'$scope'
		'setFormsDirty'
		'ProductRepository'
		'entity'
		'isVariant'
		'onSkuChange'
		'getProductsWithDuplicateSkus'

	initialize: ->
		@oldSkus = angular.copy(@getSkus())
		@productsWithDuplicateSkus = {}

		@$scope.$watch(
			@getProductsWithDuplicateSkus,
			(newValue) => @productsWithDuplicateSkus = newValue
		)

		@$uibModalInstance
			.result
			.catch =>
				@assignSkus(@oldSkus)
				@onSkuChange()

	add: ->
		if @isVariant
			@entity.product_variant_skus.push({value: null, product_variant_id: @entity.id})
		else
			@entity.product_skus.push({value: null, product_id: @entity.id})

	remove: (index) ->
		if @isVariant
			@entity.product_variant_skus.splice(index, 1)
		else
			@entity.product_skus.splice(index, 1)

	closeModal: (shouldPersistData) ->
		if shouldPersistData
			@assignSkus(_.reject(@getSkus(), (item) -> _.isEmpty(item.value)))
			@onSkuChange()

			@setFormsDirty()
			@$uibModalInstance.close(true)

			return

		@assignSkus(@oldSkus)
		@onSkuChange()

		@$uibModalInstance.close(false)

	getSkus: ->
		return @entity.product_variant_skus ? @entity.product_skus

	assignSkus: (skus) ->
		if @isVariant
			@entity.product_variant_skus = skus
		else
			@entity.product_skus = skus
